// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7aa289a0] .van-cell {\n  padding: 4vw 4vw;\n}\n.syser[data-v-7aa289a0] {\n  width: 92vw;\n  margin-left: 4vw;\n  min-height: 100vh;\n}\n.syser .syser-tab[data-v-7aa289a0] {\n  margin-top: 2.66667vw;\n  border-radius: 2.66667vw;\n  overflow: hidden;\n}\n.syser .syser-bottom[data-v-7aa289a0] {\n  width: 74.66667vw;\n  margin: 0 auto;\n  margin-top: 13.33333vw;\n  margin-bottom: 2.66667vw;\n  border-radius: 8vw;\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
